export function isChargeTotalComplete(rows) {
    return (rows ?? []).every((row) => row?.chargeComplete !== false);
}
